import { unit } from '../../common/theme/index';
import { styled } from '../../providers/context/StyletronProvider/withStyletronProvider';

export const LinkWrapper = styled('div', {
  marginTop: unit[6],
});
